import { Component } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';

@Component({
    selector: 'fi-checklist-edit-add-checkpoint-confirm',
    templateUrl: './add-checkpoint-confirm.component.html',
    standalone: false,
})
export class FiChecklistEditAddCheckpointConfirmComponent extends FiDialogsContentBase<void, void> {}
